import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2eb73ea7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex flex-column"
}
const _hoisted_2 = { class: "flex flex-column-reverse wp1200 sm:flex-row p-0" }
const _hoisted_3 = { class: "info-panel" }
const _hoisted_4 = { class: "green-card" }
const _hoisted_5 = { class: "text-2xl font-semibold" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold text-600 line-height-1" }, [
  /*#__PURE__*/_createTextVNode("CO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2")
], -1))
const _hoisted_7 = { class: "green-card" }
const _hoisted_8 = { class: "text-2xl font-semibold" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold text-600" }, "kcal", -1))
const _hoisted_10 = { class: "flex flex-column justify-content-between gap-2 border-1 border-300 border-round-2xl w-full p-3 text-base" }
const _hoisted_11 = { class: "flex justify-content-between align-items-center w-full" }
const _hoisted_12 = { class: "flex align-items-center gap-2" }
const _hoisted_13 = { class: "flex gap-1 p-2 border-1 border-300 border-round-xl w-fit h-fit" }
const _hoisted_14 = { class: "font-semibold" }
const _hoisted_15 = { class: "text-primary font-semibold" }
const _hoisted_16 = { class: "flex justify-content-between align-items-center w-full" }
const _hoisted_17 = { class: "font-semibold text-primary" }
const _hoisted_18 = { class: "text-600" }
const _hoisted_19 = {
  key: 0,
  class: "legs-connector"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "legs-line" }, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "map" }
const _hoisted_23 = { class: "sm:absolute w-full h-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouteDetailsHeader = _resolveComponent("RouteDetailsHeader")!
  const _component_IconWind = _resolveComponent("IconWind")!
  const _component_IconBarbell = _resolveComponent("IconBarbell")!
  const _component_RouteSteps = _resolveComponent("RouteSteps")!
  const _component_LegBikeInfo = _resolveComponent("LegBikeInfo")!
  const _component_LegTransitStationInfo = _resolveComponent("LegTransitStationInfo")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Map = _resolveComponent("Map")!

  return (_ctx.route)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_RouteDetailsHeader),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex flex-column gap-2 w-full sm:flex-row", { 'mb-4': _ctx.route.legs.length > 1 }])
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_IconWind, { class: "thin-icon text-3xl text-green-500" }),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.route.co2Emissions.value.toFixed(0)) + " g", 1),
                _hoisted_6
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_IconBarbell, { class: "thin-icon text-3xl text-green-500" }),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.convertJoulesToKcal(_ctx.route.humanEffort.value).toFixed(0)), 1),
                _hoisted_9
              ])
            ], 2),
            (_ctx.route.legs.length === 1)
              ? (_openBlock(), _createBlock(_component_RouteSteps, {
                  key: 0,
                  leg: _ctx.route.legs[0],
                  show: ""
                }, null, 8, ["leg"]))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.route.legs, (leg, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "route-leg-container"
                  }, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getIconComponent(leg.mode))))
                          ]),
                          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t(`route_planner.modes.${leg.mode.toLowerCase()}`)), 1)
                        ]),
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.getDuration(leg)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t("route_planner.to")) + " ", 1),
                          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.getToName(leg, index)), 1)
                        ]),
                        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.getDistance(leg.distance.value)), 1)
                      ]),
                      (_ctx.showBikeInfo(leg, index))
                        ? (_openBlock(), _createBlock(_component_LegBikeInfo, {
                            key: 0,
                            route: _ctx.route,
                            leg: leg,
                            index: index
                          }, null, 8, ["route", "leg", "index"]))
                        : _createCommentVNode("", true),
                      (_ctx.showTransitStationInfo(leg, index))
                        ? (_openBlock(), _createBlock(_component_LegTransitStationInfo, {
                            key: 1,
                            route: _ctx.route,
                            leg: leg,
                            index: index
                          }, null, 8, ["route", "leg", "index"]))
                        : _createCommentVNode("", true),
                      (leg.steps.length > 1)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 2,
                            label: _ctx.$t('route_planner.instructions'),
                            class: "button secondary small w-fit mt-2",
                            icon: "pi pi-chevron-down",
                            "icon-class": "text-xs",
                            iconPos: "right",
                            onClick: 
                () => {
                  leg.showSteps = !leg.showSteps;
                  _ctx.displayPolygons();
                }
              
                          }, null, 8, ["label", "onClick"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_RouteSteps, { leg: leg }, null, 8, ["leg"])
                    ]),
                    (index !== _ctx.route.legs.length - 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_Map, {
                center: _ctx.center,
                markers: _ctx.markers,
                geoJson: _ctx.geoJson,
                fitMarkers: true
              }, null, 8, ["center", "markers", "geoJson"])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}